import React from 'react';
import s from './Footer.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/free-regular-svg-icons';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';

export default function Footer({data}) {


    if(!data.length){
        return (
            <header className={s.footer}>
                <LoadingSpinner/>
            </header>
        )
    }

  return (
    <footer className={s.footer}>
        <div className={s.primera}>
            <ul>
                {
                    data?.map((d, i)=>{
                        return <li key={i} className={s.contactoBtn} onClick={()=>{window.scrollTo(0, document.getElementById(d.parametros.slice(5)).offsetTop-120);}}>{d.nombre}</li>
                    })
                }
                <li className={s.contactoBtn} onClick={()=>{window.scrollTo(0, document.getElementById("Contacto").offsetTop-120);}}>Contacto</li>
            </ul>
            <div className={s.emails}>
                <div className={s.emailContainer} onClick={() => { window.open('mailto:dlamas@peuma-ig.com.ar?','_blank')}}>
                    <FontAwesomeIcon className="mailIcon" icon={faEnvelope} color="#707070"/>
                    <p>dlamas@peuma-ig.com.ar</p>
                </div>
                <div className={s.emailContainer} onClick={() => { window.open('mailto:rburgos@peuma-ig.com.ar?','_blank')}}>
                    <FontAwesomeIcon className="mailIcon" icon={faEnvelope} color="#707070"/>
                    <p>rburgos@peuma-ig.com.ar</p>
                </div>
            </div>
        </div>
        <div className={s.segunda}>
            <img src={`http://www.peuma-ig.com.ar/admin/${data[0]?.imagen}`} alt="Logo Peuma" onClick={()=>{window.scrollTo(0, document.getElementById("Hero").offsetTop);}}/>
            <p>PEUMA 2022 Todos los derechos reservados.</p>
        </div>
        <div className={s.tercera}>
        <iframe title='Maps' src={``} className={s.iframe} allowFullScreen></iframe>
        </div>
    </footer>
  )
}

// https://maps.google.com/maps?q=-34.527348126436884,-58.53490686416626&output=svembed
